import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { CloudflareAccount, CloudflareAccountsFormFields, CloudflareAccountsQueryKeys } from '@/modules/DomainsApi';


export const useGetAllCloudflareAccountsQuery = (paginationOptions: AppPaginationOptions, search?: string) =>
  buildQuery<WithPagination<Pick<CloudflareAccount, 'id' | 'email'>>, QueryError>([CloudflareAccountsQueryKeys.GetAll, { ...paginationOptions, search }], async () => {
    const { data } = await apiExecutor.get(ApiRoutes.DomainsApiCloudflareAccounts, {
      params: { ...paginationOptions, search }
    });
    return data;
  });

export const useGetByIdCloudflareAccountsQuery = (id: string) =>
  buildQuery<CloudflareAccount, QueryError>([CloudflareAccountsQueryKeys.GetOneById, id], async () => {
    const { data } = await apiExecutor.get<CloudflareAccount>(
      ApiRoutes.DomainsApiCloudflareAccountsById.replace(':cloudflareAccountId', id)
    );
    return data;
  });

export const useCreateCloudflareAccountsMutation = () =>
  buildMutation<CloudflareAccount, QueryError, CloudflareAccountsFormFields>(
    [CloudflareAccountsQueryKeys.Create],
    async (postData) => {
      const { data } = await apiExecutor.post<CloudflareAccount>(ApiRoutes.DomainsApiCloudflareAccounts, {
        ...postData
      }, { params: { teamId: localStorage.getItem('currentTeamId') } });
      return data;
    }
  );

export const useEditCloudflareAccountsMutation = (id: string) =>
  buildMutation<CloudflareAccount, QueryError, CloudflareAccountsFormFields>(
    [CloudflareAccountsQueryKeys.Edit],
    async (postData) => {
      const { data } = await apiExecutor.patch<CloudflareAccount>(ApiRoutes.DomainsApiCloudflareAccountsById.replace(':cloudflareAccountId', id), {
        ...postData
      });
      return data;
    }
  );

export const useDeleteCloudflareAccountsMutation = (cloudflareAccountId: string) =>
  buildMutation<void, QueryError, void>([CloudflareAccountsQueryKeys.Create], async () => {
    const { data } = await apiExecutor.delete<void>(
      ApiRoutes.DomainsApiCloudflareAccountsById.replace(':cloudflareAccountId', cloudflareAccountId)
    );
    return data;
  });

export const useAutocompleteCloudflareAccountsQuery = (params: { query: string; includedIds?: string[]; }) =>
  buildQuery<Pick<CloudflareAccount, 'id' | 'email'>[], QueryError>(
    [CloudflareAccountsQueryKeys.Autocomplete, params],
    async () => {
      const { data } = await apiExecutor.get<Pick<CloudflareAccount, 'id' | 'email'>[]>(
        ApiRoutes.DomainsApiCloudflareAccountsAutocomplete,
        { params: { q: params.query, includedIds: params?.includedIds?.length ? String(params.includedIds) : undefined, } }
      );
      return data;
    }
  );

export const useBreadcrumbCloudflareAccountsQuery = (id: string) =>
  buildQuery<string, QueryError>([CloudflareAccountsQueryKeys.Breadcrumb, id], async () => {
    const { data } = await apiExecutor.get<string>(
      ApiRoutes.DomainsApiCloudflareAccountsBreadcrumb.replace(':cloudflareAccountId', id)
    );
    return data;
  });
